/** @format */

import React from "react";
import { THome } from "../../../../redux-modules/declarations/maps/home";
import { giornoMese } from "../format";

/**
 * Contatori di chi è collegato: giorni di ferie e malattia e ore di ROL accettati dalla data di
 * azzeramento della tenance (stessi numeri della Home precedente). La banca ore non si mostra.
 */
export const Contatori = ({ contatori }: { contatori: THome["contatori"] }): JSX.Element => (
  <section className="scheda" aria-labelledby="titolo-contatori">
    <div className="testa">
      <h2 id="titolo-contatori">I miei contatori</h2>
      {contatori && <span className="attenuato">accettati dal {giornoMese(contatori.dal)}</span>}
    </div>
    {contatori ? (
      <div className="contatori">
        <div className="contatore">
          <span className="valore numeri">
            {contatori.ferie_giorni}
            <small>gg</small>
          </span>
          <span className="tacca" style={{ background: "#EA9161" }} />
          <span className="nome">Ferie</span>
        </div>
        <div className="contatore">
          <span className="valore numeri">
            {contatori.malattia_giorni}
            <small>gg</small>
          </span>
          <span className="tacca" style={{ background: "#AD2E61" }} />
          <span className="nome">Malattia</span>
        </div>
        <div className="contatore">
          <span className="valore numeri">
            {contatori.rol_ore}
            <small>h</small>
          </span>
          <span className="tacca" style={{ background: "#80C2C1" }} />
          <span className="nome">ROL</span>
        </div>
      </div>
    ) : (
      <span className="vuoto">Contatori non disponibili.</span>
    )}
  </section>
);
